import React, { useEffect }  from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { paramsToObject } from '../Functions/Helpers';
import { GetDataPromise } from '../Functions/SendingData';
import { apiMain } from '../../App';
import { LoadingFull } from '../LoadingFull';
import AgencyCart from './SmallComps/AgencyCart';
import { Loading } from '../Loading';
import EndObserver from '../Functions/EndObserver';
const Styles = styled.div`
  width: calc(100% - calc(var(--universal-pad) * 2));
  margin: 0 var(--universal-pad) 1rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  @media screen and (max-width: 850px) {
    grid-template-columns: repeat(1, 1fr);
  }
`
export default function AgencyList15 (props){
  const {data: dataRaw, lan, agency} = props;
  const data = JSON.parse(dataRaw);
  const location = useLocation();
  const navigate = useNavigate();
  const [baseSearch, setBaseSearch] = useState(location.search)
  const [pageData, setPageData] = useState([]);
  const [meta, setMeta] = useState({})
  const [loading, setLoading] = useState(false);
  const [loadingS, setLoadingS] = useState(false);

  const [paginate, setPaginate] = useState(10)
  const [page, setPage] = useState(1);

  const paramsBase = new URLSearchParams(baseSearch);
  const params = paramsToObject(paramsBase);
  useEffect(() => {
    if(location.search !== baseSearch){
      setBaseSearch(location.search);
    }
  }, [location.search])
  
  useEffect(() => {
    getData()
  }, []);
  useEffect(() => {
    getData(false);
  }, [baseSearch]);

  const getData = async(isLoading = true, force = false) => {
    if(isLoading){
      setLoading(true);
    }
    setLoadingS(true);
    let URLparams = new URLSearchParams();
    let availableVal = [
      "Agency_Name",
      "Country_Id",
      "City_Id",
      "Agency_Type_Id",
      "page",
      "rows"
    ]
    
    for (let i = 0; i < availableVal.length; i++) {
      const element = availableVal[i];
      if(paramsBase.get(element)) {
        URLparams.append(element, paramsBase.get(element))
      }
    }
    if(!paramsBase.get("rows")){
      URLparams.append("rows", paginate)
    }
    let newpage = URLparams.get("page");
    let newrows = URLparams.get("rows");
    if(pageData.length !== (newpage - 1) * newrows){
      let temp = {...params};
      temp["page"] = 1;
      temp["rows"] = 10;
      setPage(1)
      setPaginate(10)
      let URLparams2 = new URLSearchParams();
      for (let i = 0; i < Object.keys(temp).length; i++) {
        const element = Object.keys(temp)[i];
        if(temp[element]){
          URLparams2.append(element, temp[element]);
        }
      }
      navigate(location.pathname + "?" + URLparams2.toString())
      return;
    }
    
    let res = await GetDataPromise(`${apiMain}/api/v1/agencies/agency/searchname?${URLparams.toString()}`, force);
    let parsed = JSON.parse(res);
    if((parsed.status && parsed.status !== "error" && parsed.status !== "error-no-internet") || parsed.status === "success"){
      if(parsed.data.data.length){
        let tempData = [...pageData];
        if(tempData.length < parsed.data.from){
          tempData.push(...parsed.data.data);
        }
        setPageData(tempData);
        setMeta({
          ...parsed.data,
          data: []
        });
        setPage(parsed.data.current_page)
        setPaginate(parseInt(parsed.data.per_page))

        setLoading(false);
        setLoadingS(false);
        return;
      }
      setLoading(false);
      setLoadingS(false);
    }
    setPageData([]);
    setLoading(false);
    setLoadingS(false);
  }
  const loadMore = () => {
    if(loadingS || loading){
      return;
    }
    let temp = {...params};
    let newPage = page + 1;
    let pagination = paginate
    if(newPage > meta.last_page){
      return;
    }
    temp["page"] = newPage;
    temp["rows"] = pagination;
    setPage(newPage)
    setPaginate(pagination)
    let URLparams = new URLSearchParams();
    for (let i = 0; i < Object.keys(temp).length; i++) {
      const element = Object.keys(temp)[i];
      if(temp[element]){
        URLparams.append(element, temp[element]);
      }
    }
    navigate(location.pathname + "?" + URLparams.toString())
  }
  if(loading){
    return (
        <LoadingFull/>
    )
  }
  
  const makeItems = () => {
    if(!pageData.length){
      return (
        <div className='no-match'>
          no match
        </div>
      )
    }
    let items = pageData.map((v, i) => {
      return (
        <AgencyCart v={v} i={i} key={i} lan={lan}/>
      )
    })
    return (
      <>
        {items}
        {
          (loadingS) ? (
            <Loading/>
          ) : (
            <EndObserver func={loadMore}/>
          )
        }
      </>
    )
  }
  return (
    <Styles>
      {makeItems()}
    </Styles>
  )
}

